import { Trans, useTranslation } from "react-i18next";

import React, { useEffect, useMemo, useState } from "react";
import {
  CheckoutCard,
  CheckoutCardContent,
  CheckoutCardSubHeader,
  CheckoutCardTitle,
} from "./CheckoutCard";
import List from "@material-ui/core/List";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import ListItemRadioButton from "../../../components/Common/ListItemRadioButton";
import { useCheckout } from "../../providers/CheckoutProvider";
import { useFormik, Field, FormikProvider } from "formik";
import { getYUPValidators } from "../../../components/yupvalidators";
import * as Yup from "yup";
import { TextField } from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";
import { Skeleton } from "@material-ui/lab";
import { useAuth } from "../../providers/AuthProvider";
import useIsMobileDevice from "../../../hooks/useIsMobileDevice";
import useTheme from "@material-ui/core/styles/useTheme";
import InputMobileNumber from "../../Desktop/Pages/SubjectRegistration/Components/InputMobileNumber";

const useStyles = makeStyles((theme) => ({
  selectedPaymentOption: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: "15px",
    fontWeight: 500,
  },
  selectedPaymentOptionInfo: {},
  secondaryText: {
    color: "#777",
    fontSize: "0.8rem",
    fontWeight: 400,
  },
  actionButtonContainer: {
    paddingRight: theme.clientType == "desktop" ? 0 : theme.spacing(2),
    [theme.breakpoints.down("xs")]: {
      paddingRight: theme.spacing(1),
    },
  },
  paymentProviderIcon: {
    height: "30px",
    width: "auto",
    marginBottom: "3px",
  },
}));

const SelectPaymentOption = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  const {
    isLoadingPaymentOptions,
    paymentOptions,
    paymentOption,
    setPaymentOption,
    state,
    setCurrentStep,
  } = useCheckout();
  const [currentPaymentOption, setCurrentPaymentOption] = useState();
  const { user } = useAuth();

  const initialFormValues = useMemo(() => {
    const initialValues = {};
    if (currentPaymentOption?.verifyMobile) {
      initialValues.mobilePhone = user.mobilePhone ?? "";
    }
    if (
      currentPaymentOption?.verifyMobile ||
      currentPaymentOption?.requirePersonNo
    ) {
      initialValues.pid = "";
    }
    return initialValues;
  }, []);

  const theme = useTheme();
  const isMobileDevice = useIsMobileDevice();
  console.log("Initial values", initialFormValues);

  useEffect(() => {
    if (paymentOptions && paymentOptions.length > 0) {
      setCurrentPaymentOption(paymentOptions[0]);
    }
  }, [paymentOptions]);

  useEffect(() => {
    const thePaymentOption =
      paymentOption &&
      paymentOptions &&
      paymentOptions.find((po) => po.uuid == paymentOption.uuid);
    if (thePaymentOption) {
      setCurrentPaymentOption(thePaymentOption);
    }
  }, [paymentOptions, paymentOption]);

  const formik = useFormik({
    initialValues: initialFormValues,
    validateOnMount: true,
    validationSchema: schema(currentPaymentOption, t),
    onSubmit: (values) => {
      setPaymentOption(currentPaymentOption, values);
    },
  });

  useEffect(() => {
    // If it change, reevaluate, so button get disabled?
    console.log(formik);
    formik.validateForm();
  }, [currentPaymentOption]);

  const { isValid } = formik;

  console.log("Theee state is", state);

  if (isLoadingPaymentOptions) {
    return (
      <CheckoutCard>
        <CheckoutCardTitle active={false}>
          <Trans>2. Payment</Trans>
        </CheckoutCardTitle>
        <List>
          <ListItemRadioButton
            primaryText={<Skeleton variant="text" />}
            disabled={true}
            secondaryText={<Skeleton variant="text" />}
          />
          <ListItemRadioButton
            primaryText={<Skeleton variant="text" />}
            disabled={true}
            secondaryText={<Skeleton variant="text" />}
          />
        </List>
      </CheckoutCard>
    );
  } else if (
    paymentOptions &&
    paymentOptions.length > 0 &&
    state.currentStep == "select-payment-option"
  ) {
    return (
      <FormikProvider value={formik}>
        <CheckoutCard>
          <CheckoutCardTitle active={true}>
            <Trans>2. Payment</Trans>
          </CheckoutCardTitle>

          <form onSubmit={formik.handleSubmit}>
            <List>
              {paymentOptions.map((paymentOption, idx) => {
                let description = (
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        paymentOption.mobileDescription ||
                        paymentOption.description,
                    }}
                  ></div>
                );

                console.log("Payment option", paymentOption);

                return (
                  <ListItemRadioButton
                    key={paymentOption.uuid}
                    labelId={"po_" + paymentOption.uuid}
                    selected={paymentOption == currentPaymentOption}
                    name="paymentOption"
                    onClick={() => {
                      setCurrentPaymentOption(paymentOption);
                    }}
                    primaryText={
                      paymentOption.mobileTitle || paymentOption.title
                    }
                    secondaryText={description}
                    action={
                      <PaymentMethodIcons
                        enabledPaymentMethods={
                          paymentOption.enabledPaymentMethods
                        }
                      />
                    }
                  />
                );
              })}
            </List>
            <CheckoutCardContent>
              {(currentPaymentOption?.verifyMobile ||
                currentPaymentOption?.requirePersonNo) && (
                <>
                  <CheckoutCardSubHeader>
                    <Trans>Payment details</Trans>
                  </CheckoutCardSubHeader>

                  {currentPaymentOption?.verifyMobile && (
                    <Field
                      label={t("Your mobile number")}
                      name="mobilePhone"
                      component={InputMobileNumber}
                      variant="standard"
                    />
                  )}

                  {currentPaymentOption?.requirePersonNo && (
                    <FormikTextInput
                      formik={formik}
                      label={t("Personal number")}
                      name="pid"
                      displayInputHint={true}
                    />
                  )}
                </>
              )}

              <Box mt={2} display="flex" justifyContent="flex-end">
                <Button
                  variant="contained"
                  color="primary"
                  disabled={!isValid}
                  type="submit"
                >
                  <Trans>Next step</Trans>
                </Button>
              </Box>
            </CheckoutCardContent>
          </form>
        </CheckoutCard>
      </FormikProvider>
    );
  } else if (paymentOption && paymentOptions && paymentOptions.length) {
    let description = (
      <div
        dangerouslySetInnerHTML={{
          __html: paymentOption.mobileDescription || paymentOption.description,
        }}
      ></div>
    );

    return (
      <CheckoutCard>
        <Box display="flex" flexDirection={isMobileDevice ? "column" : "row"}>
          <CheckoutCardTitle active={false} complete={true}>
            <Trans>2. Payment</Trans>
          </CheckoutCardTitle>
          <Box
            display="flex"
            justifyContent="space-between"
            flexGrow={1}
            pb={isMobileDevice ? 2 : 0}
          >
            <Box
              px={3}
              py={theme.clientType != "desktop" && !isMobileDevice ? 2 : 0}
            >
              <div className={classes.selectedPaymentOption}>
                <div className={classes.selectedPaymentOptionInfo}>
                  <div>{paymentOption.title}</div>
                  <div className={classes.secondaryText}>{description}</div>
                </div>
              </div>
            </Box>
            <Box
              display="flex"
              alignItems="center"
              className={classes.actionButtonContainer}
            >
              {paymentOptions.length > 0 && (
                <IconButton
                  onClick={() => setCurrentStep("select-payment-option")}
                  color="primary"
                  aria-label={t("Edit payment option")}
                >
                  <Icon>edit</Icon>
                </IconButton>
              )}
            </Box>
          </Box>
        </Box>
      </CheckoutCard>
    );
  }

  return (
    <CheckoutCard>
      <CheckoutCardTitle disabled={true}>
        <Trans>2. Payment</Trans>
      </CheckoutCardTitle>
      {isLoadingPaymentOptions && <div>Loading</div>}
    </CheckoutCard>
  );
};

const FormikTextInput = ({ formik, name, label, displayInputHint }) => {
  console.log("Formik text field", formik);
  return (
    <TextField
      fullWidth
      name={name}
      label={label}
      value={formik.values[name]}
      onBlur={formik.handleBlur}
      onChange={formik.handleChange}
      error={formik.touched[name] && Boolean(formik.errors[name])}
      helperText={
        (displayInputHint || formik.touched[name]) && formik.errors[name]
      }
    />
  );
};

const PaymentMethodIcons = ({ enabledPaymentMethods }) => {
  const classes = useStyles();

  console.log("Enabled payment providers", enabledPaymentMethods);
  /*
  enabledPaymentProviders = [
    "google-pay",
    "apple-pay",
    "afterpay",
    "swish",
    "vipps",
  ];

   */
  if (!enabledPaymentMethods || enabledPaymentMethods.length === 0) {
    return null;
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      flexShrink={0}
    >
      {enabledPaymentMethods.map((paymentProvider) => {
        return (
          <Box key={paymentProvider.name} display="flex">
            <img
              className={classes.paymentProviderIcon}
              src={`/design/DEFAULT/graphics/paymentproviders/${paymentProvider.icon}.svg`}
              alt={paymentProvider.name}
            />
          </Box>
        );
      })}
    </Box>
  );
};

const schema = (paymentOption, t) => () => {
  const validators = getYUPValidators(t);
  const shape = {};

  if (paymentOption?.verifyMobile) {
    shape.mobilePhone =
      validators.MOBILE_PHONE_WITH_SERVER_VALIDATION.required(
        t("This is required!"),
      );
  }

  if (paymentOption?.requirePersonNo) {
    shape.pid = validators.PERSONAL_ID_NUMBER_WITH_MIN_AGE.required(
      t("This is required!"),
    );
  }

  return Yup.object().shape(shape);
};

export default SelectPaymentOption;
